import * as types from "./mutation-types";

const initialState = {
  raceData: {},
};

const mutations = {
  [types.PUT_RACE_DATA](state, raceData) {
    state.raceData = raceData;
  },
};

const actions = {
  async fetchRaceData(context, raceId) {
    const url = `https://forecasting-data.decisiondeskhq.com/2022/prod/races/${raceId}.json`;

    await fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        return response.json();
      })
      .then((raceData) => {
        context.commit(types.PUT_RACE_DATA, raceData)
        return raceData
      })
      .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(`Unable to fetch data for race ${raceId}. Encountered error: ${error.message}`);
      });
  },
}

const getters = {
  raceData(state) {
    return state.raceData;
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
};
